/* unplugin-vue-components disabled */import script from "./aiquestion.vue?vue&type=script&setup=true&lang=js"
export * from "./aiquestion.vue?vue&type=script&setup=true&lang=js"

import "./aiquestion.vue?vue&type=style&index=0&id=565b091a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-565b091a"]])

export default __exports__